import { useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import useUiuxStore from "src/store/useUiuxStore";
import { Content_TQC2100_R01 } from "./Content_TQC2100_R01";
import { Table_TQC2100_R01 } from "./Table_TQC2100_R01";
import {
	defaultTQC2100_R01HeaderDto,
	TQC2100_R01DetailPivotDto,
} from "./Dto_TQC2100_R01";
import { Info_TQC2100_R01 } from "./Info_TQC2100_R01";
import { SearchSection_TQC2100_R01 } from "./SearchSection_TQC2100_R01";

/** 액션바, 검색조건, 기본정보, 측정 그리드를 조합하는 화면 최상위 컴포넌트 */
export const Container_TQC2100_R01 = () => {
	const { tabList, setMessage } = useUiuxStore();
	const detailGridRef = useRef<AgGridReact<TQC2100_R01DetailPivotDto>>(null);
	// 화면 업무 로직은 Content 훅에 위임하고 Container는 배치만 담당한다.
	const {
		fetchData,
		handleInsertClick,
		handleDeleteClick,
		handleSaveClick,
		handlePrintClick,
		handleExcelClick,
		initContainerData,
	} = Content_TQC2100_R01({ detailGridRef, tabList, setMessage });
	return (
		<div className="content-container">
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={handleInsertClick}
				onDeleteClick={handleDeleteClick}
				onSaveClick={handleSaveClick}
				onPrintClick={handlePrintClick}
				onExcelClick={handleExcelClick}
				onInitClick={initContainerData}
			/>
			<SearchSection_TQC2100_R01 />
			<Info_TQC2100_R01
				defaultTQC2100_R01HeaderRow={defaultTQC2100_R01HeaderDto}
			/>
			<div className="flex flex-1 p-[12px] min-h-0">
				<Table_TQC2100_R01 gridRef={detailGridRef} />
			</div>
			<Message />
		</div>
	);
};
